import { render, staticRenderFns } from "./workpackage-settings-icon.vue?vue&type=template&id=08d2c932"
import script from "./workpackage-settings-icon.vue?vue&type=script&lang=js"
export * from "./workpackage-settings-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports